






































import Vue from "vue";
import AppNavigation from "./AppNavigation.vue";
import SlideNavigation from "./SlideNavigation.vue";

export default Vue.extend({
  components: {
    AppNavigation,
    SlideNavigation,
  },

  methods: {
    handleMenuClick(event: Event): void {
      this.$store.state.slideMenuOpen = !this.$store.state.slideMenuOpen;
    },
  },
});
